export default {
  '1_WEEKS': '1 week',
  '2_WEEKS': '2 weeks',
  '3_WEEKS': '3 weeks',
  '4_WEEKS': '4 weeks',
};
